<template>
  <div id="app"  >
    <transition name="van-slide-left">
      <router-view v-show="appVisibel" />
    </transition>
    <div class="usrmenu-box">
      <van-popup
        v-if="show"
        v-model="show"
        position="left"
        :style="{ height: '100vh', width: '70vw' }"
      >
        <WebUsrMenu :usr="usr" />
      </van-popup>
    </div>
    <div class="safe-box">
      <van-popup v-model="safeboxshow" v-if="safeboxshow" closeable round>
        <SafeBox ref="safe" @closep2="closep2" :usr="usr" />
      </van-popup>
    </div>
   
  </div>
</template>

<script>
import WebUsrMenu from './components/UsrMenu/index.vue'
import SafeBox from './components/SafeBox/index.vue'
export default {
  name: 'AppView',
  components: { WebUsrMenu, SafeBox },
  provide () {
    return {
      app: this
    }
  },
  data () {
    return {
      appVisibel: true,
      show: false,
      usr: {},
      safeboxshow: false,
      wapConfig:null,
    }
  },
  watch: {
    $route (to,from) {
      this.show = false
      console.log(to)
      console.log(from)
    },
    show (val) {
      if (val) this.getusrInf()
    },
    safeboxshow (val) {
      if (val) {
        this.clearfrm()
        this.getusrInf()
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    toShowUsrMenu () {
      this.show = true
    },
    toShowbox(){
      this.safeboxshow = true
    },
    
    clearfrm () {
      //this.$refs.safe.type = '1'
      //this.$refs.safe.pay_pass = null
      //this.$refs.safe.admount = null
      //if (this.$refs.safe.refs.frm) {
      //  this.$refs.safe.refs.frm.resetValidation()
      //}
    },
    async getSetting () {
      await this.$http({
        method: 'post',
        url: 'syssetting'
      }).then(data => {
         this.wapConfig = data.data
        let link = document.createElement('link')
        link.rel = 'icon'
        link.href = this.wapConfig.site_logo
        link.type = 'image/x-icon'
        document.head.appendChild(link)
        document.title = this.wapConfig.title
      })
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.usr = data.data
      })
    },
   
  }
}
</script>

<style lang="scss"></style>
